<div class="space-y-6 animate-fade-in-up">


  <!-- 1. FILTERS (Maintained strictly with bound models) -->

  <div class="bg-white p-5 rounded-2xl shadow-sm border border-gray-100 mb-6">
    <!-- Use a 12-column grid for better control over spacing -->
    <div class="grid grid-cols-1 md:grid-cols-12 gap-4 items-end">

      <!-- 1. Quick Filter Toggles (Today/Monthly/Yearly) - Spans 4 columns -->
      <div class="md:col-span-4 flex flex-col gap-1.5">
        <label class="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Period Selection</label>
        <div class="flex bg-gray-100 p-1 rounded-lg border border-gray-200">
          <button (click)="setDateFilter('today')"
            [ngClass]="activeFilter === 'today' ? 'bg-white shadow-sm text-orange-600' : 'text-gray-500 hover:bg-gray-200'"
            class="flex-1 py-2 rounded-md text-[11px] font-bold transition-all uppercase">
            Today
          </button>
          <button (click)="setDateFilter('monthly')"
            [ngClass]="activeFilter === 'monthly' ? 'bg-white shadow-sm text-orange-600' : 'text-gray-500 hover:bg-gray-200'"
            class="flex-1 py-2 rounded-md text-[11px] font-bold transition-all uppercase mx-1">
            Monthly
          </button>
          <button (click)="setDateFilter('yearly')"
            [ngClass]="activeFilter === 'yearly' ? 'bg-white shadow-sm text-orange-600' : 'text-gray-500 hover:bg-gray-200'"
            class="flex-1 py-2 rounded-md text-[11px] font-bold transition-all uppercase">
            Yearly
          </button>
        </div>
      </div>
      <!-- Firm/Branch -->
      <!-- <div class="flex flex-col gap-1.5">
    <label class="text-xs font-bold text-gray-500 uppercase tracking-wide">
      Firm/Branch
    </label>

    <select class="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm text-gray-700
            focus:ring-2 focus:ring-yellow-500/20 focus:border-yellow-500
            outline-none bg-white transition-all" (change)="onFirmChange($event)" [value]="selectedFirmId">
      <option value="">All Firms</option>

      <option *ngFor="let firm of firms" [value]="firm.id">
        {{ firm.name }}
      </option>
    </select>
  </div> -->

      <!-- Metal Type (Commented Original Block)
  <div class="flex flex-col gap-1.5">
    <label class="text-xs font-bold text-gray-500 uppercase tracking-wide">Metal Type</label>
    <select class="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm text-gray-700 focus:ring-2 focus:ring-yellow-500/20 focus:border-yellow-500 outline-none bg-white transition-all">
      <option>All (Gold/Silver)</option>
      <option>Gold Only</option>
      <option>Silver Only</option>
    </select>
  </div> -->

      <!-- Item Category (Commented Original Block)
  <div class="flex flex-col gap-1.5">
    <label class="text-xs font-bold text-gray-500 uppercase tracking-wide">Item Category</label>
    <select class="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm text-gray-700 focus:ring-2 focus:ring-yellow-500/20 focus:border-yellow-500 outline-none bg-white transition-all">
      <option>All Categories</option>
      <option>Rings</option>
      <option>Chains</option>
    </select>
  </div> -->
      <!-- 2. Date From - Spans 2 columns -->
      <div class="md:col-span-2 flex flex-col gap-1.5">
        <label class="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Date From</label>
        <div class="relative">
          <input type="date" [(ngModel)]="dateFrom"
            class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-700 focus:ring-2 focus:ring-orange-500/20 focus:border-orange-500 outline-none bg-white transition-all">
        </div>
      </div>

      <!-- 3. Date To - Spans 2 columns -->
      <div class="md:col-span-2 flex flex-col gap-1.5">
        <label class="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Date To</label>
        <div class="relative">
          <input type="date" [(ngModel)]="dateTo"
            class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-700 focus:ring-2 focus:ring-orange-500/20 focus:border-orange-500 outline-none bg-white transition-all">
        </div>
      </div>

      <!-- 4. Action Buttons (Clear/Apply) - Spans 4 columns -->
      <div class="md:col-span-4 flex gap-2">
        <button (click)="clearFilters()"
          class="flex-1 bg-white hover:bg-gray-50 text-gray-500 font-bold py-2 rounded-lg text-xs transition-colors border border-gray-200 uppercase tracking-wider">
          Clear
        </button>
        <button (click)="refreshAllData()"
          class="flex-[2] bg-gradient-to-r from-orange-600 to-orange-500 hover:from-orange-700 hover:to-orange-600 text-white font-bold py-2 rounded-lg text-xs shadow-md shadow-orange-500/20 transition-all uppercase tracking-wider">
          Apply Filters
        </button>
      </div>

    </div>
  </div>

  <!-- 🔹 INCREASED CODE: RECONCILIATION SUMMARY (Financial & Metal) -->
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
    <!-- Financial Reconciliation Card -->
    <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
      <div class="flex justify-between items-center mb-4">
        <h3 class="font-bold text-gray-800 text-sm flex items-center gap-2">
          <span class="material-icons text-green-500">payments</span> Amount
        </h3>
        <span
          class="text-[10px] bg-green-50 text-green-600 px-2 py-1 rounded-full font-bold uppercase tracking-widest">Recovery</span>
      </div>
      <div class="grid grid-cols-3 gap-4 mb-4">
        <div>
          <p class="text-[10px] text-gray-400 font-bold uppercase">Billed</p>
          <p class="text-lg font-bold text-gray-800">₹{{totalAmountBilled | number}}</p>
        </div>
        <div>
          <p class="text-[10px] text-gray-400 font-bold uppercase">Collected</p>
          <p class="text-lg font-bold text-green-600">₹{{totalAmountReceived | number}}</p>
        </div>
        <div>
          <p class="text-[10px] text-gray-400 font-bold uppercase">Due</p>
          <p class="text-lg font-bold text-rose-600">₹{{totalAmountDue | number}}</p>
        </div>
      </div>
      <div class="w-full bg-gray-100 h-3 rounded-full overflow-hidden flex">
        <div class="bg-green-500 h-full transition-all duration-700"
          [style.width.%]="totalAmountBilled ? (totalAmountReceived/totalAmountBilled)*100 : 0"></div>
        <div class="bg-rose-400 h-full transition-all duration-700"
          [style.width.%]="totalAmountBilled ? (totalAmountDue/totalAmountBilled)*100 : 0"></div>
      </div>
      <div class="mt-2 flex justify-between text-[10px] font-bold text-gray-400 uppercase tracking-tighter">
        <span>Collection: {{ (totalAmountBilled ? (totalAmountReceived/totalAmountBilled)*100 : 0) | number:'1.0-0'
          }}%</span>
        <span>Outstanding: {{ (totalAmountBilled ? (totalAmountDue/totalAmountBilled)*100 : 0) | number:'1.0-0'
          }}%</span>
      </div>
    </div>

    <!-- Metal Balance Card -->
    <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
      <div class="flex justify-between items-center mb-4">
        <h3 class="font-bold text-gray-800 text-sm flex items-center gap-2">
          <span class="material-icons text-blue-500">fitness_center</span> Metal Balance (Silver)
        </h3>
        <span
          class="text-[10px] bg-blue-50 text-blue-600 px-2 py-1 rounded-full font-bold uppercase tracking-widest">Stock</span>
      </div>
      <div class="grid grid-cols-4 gap-2 mb-4">
        <div>
          <p class="text-[10px] text-gray-400 font-bold uppercase">Total Metal</p>
          <p class="text-lg font-bold text-gray-800">{{totalMetalBilled | number}}g</p>
        </div>
        <div>
          <p class="text-[10px] text-gray-400 font-bold uppercase">Received</p>
          <p class="text-lg font-bold text-blue-600">{{totalMetalReceived | number}}g</p>
        </div>
        <div>
          <p class="text-[10px] text-gray-400 font-bold uppercase">Converted To Amount</p>
          <p class="text-lg font-bold text-purple-600">{{totalMetalSettled | number}}g</p>
        </div>
        <div>
          <p class="text-[10px] text-gray-400 font-bold uppercase">Due</p>
          <p class="text-lg font-bold text-orange-600">{{totalMetalDue | number}}g</p>
        </div>
      </div>
      <div class="w-full bg-gray-100 h-3 rounded-full overflow-hidden flex">
        <div class="bg-blue-500 h-full transition-all duration-700"
          [style.width.%]="totalMetalBilled ? (totalMetalReceived/totalMetalBilled)*100 : 0"></div>
        <div class="bg-purple-400 h-full transition-all duration-700"
          [style.width.%]="totalMetalBilled ? (totalMetalSettled/totalMetalBilled)*100 : 0"></div>
        <div class="bg-orange-400 h-full transition-all duration-700"
          [style.width.%]="totalMetalBilled ? (totalMetalDue/totalMetalBilled)*100 : 0"></div>
      </div>
      <div class="mt-2 flex justify-between text-[10px] font-bold text-gray-400 uppercase tracking-tighter">
        <span>Settled: {{ (totalMetalBilled ? ((totalMetalReceived + totalMetalSettled)/totalMetalBilled)*100 : 0) |
          number:'1.0-0' }}%</span>
        <span>Pending: {{ (totalMetalBilled ? (totalMetalDue/totalMetalBilled)*100 : 0) | number:'1.0-0' }}%</span>
      </div>
    </div>
  </div>


  <!-- 2. TOP ROW: KPIs (Original Style Maintained) -->

  <!-- <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
    <div class="bg-gradient-to-br from-yellow-50 to-white p-6 rounded-2xl shadow-sm border border-yellow-100 relative overflow-hidden group">
      <div class="absolute right-0 top-0 h-20 w-20 bg-yellow-100 rounded-bl-full opacity-50 transition-transform group-hover:scale-110"></div>
      <p class="text-xs font-bold text-yellow-700 uppercase tracking-widest mb-2">Item Revenue (Transaction)</p>
      <h3 class="text-3xl font-extrabold text-gray-800">
        ₹ {{ totalReadyAmt?.total_amount_paid | number }}
      </h3>
      <p class="text-xs text-green-600 font-bold mt-2">▲ Live Calculation</p>
    </div>

   <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-all duration-300">
    <div class="flex justify-between items-start mb-4">
        <div>
            <p class="text-xs font-semibold text-gray-500 tracking-wider uppercase mb-1">
                Ready Product Sale
            </p>
            <h3 class="text-3xl font-bold text-gray-900 leading-tight">
                ₹ {{ totalReadyProductSale | number:'1.0-0' }}
            </h3>
        </div>
        <div class="p-3 bg-blue-100 text-blue-700 rounded-xl shadow-sm">
            <span class="material-icons text-xl">store</span>
        </div>
    </div>

    <div class="mt-4">
        <div class="flex justify-between items-center mb-1">
            <span class="text-[11px] tracking-wide text-gray-500 font-medium uppercase">
                Contribution
            </span>
            <span class="text-sm font-bold text-blue-600">
                {{ totalReadyAmt?.total_amount_paid ? ((totalReadyProductSale / totalReadyAmt.total_amount_paid) * 100 | number:'1.0-0') : 0 }}%
            </span>
        </div>
        <div class="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
            <div class="bg-blue-500 h-2 rounded-full" [style.width.%]="totalReadyAmt?.total_amount_paid ? (totalReadyProductSale / totalReadyAmt.total_amount_paid) * 100 : 0"></div>
        </div>
    </div>
</div>


   <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-all duration-300">
    <div class="flex justify-between items-start mb-4">
        <div>
            <p class="text-xs font-semibold text-gray-500 tracking-wider uppercase mb-1">
                Assembly Line Sale
            </p>
            <h3 class="text-3xl font-bold text-gray-900 leading-tight">
                ₹ {{ totalAssemblyAmt | number }}
            </h3>
        </div>
        <div class="p-3 bg-purple-100 text-purple-700 rounded-xl shadow-sm">
            <span class="material-icons text-xl">engineering</span>
        </div>
    </div>

    <div class="mt-4">
        <div class="flex justify-between items-center mb-1">
            <span class="text-[11px] tracking-wide text-gray-500 font-medium uppercase">
                Contribution
            </span>
            <span class="text-sm font-bold text-purple-600">
                {{ totalReadyAmt?.total_amount_paid ? ((totalAssemblyAmt / totalReadyAmt.total_amount_paid) * 100 | number:'1.0-0') : 0 }}%
            </span>
        </div>
        <div class="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
            <div class="bg-purple-500 h-2 rounded-full" [style.width.%]="totalReadyAmt?.total_amount_paid ? (totalAssemblyAmt / totalReadyAmt.total_amount_paid) * 100 : 0"></div>
        </div>
    </div>
</div>
</div> -->

  <!-- <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
    <div class="bg-white p-6 rounded-2xl shadow-sm border-l-4 border-orange-500 flex justify-between items-center transition-all hover:shadow-md">
      <div><p class="text-xs font-bold text-gray-400 uppercase mb-1">Lot-Wise Sales</p><h3 class="text-2xl font-extrabold text-gray-800">₹ {{ lotWiseSale | number }}</h3></div>
      <div class="p-3 bg-orange-50 text-orange-600 rounded-full"><span class="material-icons">inventory_2</span></div>
    </div>
    <div class="bg-white p-6 rounded-2xl shadow-sm border-l-4 border-green-500 flex justify-between items-center transition-all hover:shadow-md">
      <div><p class="text-xs font-bold text-gray-400 uppercase mb-1">Piece-Wise Sales</p><h3 class="text-2xl font-extrabold text-gray-800">₹ {{ pieceWiseSale | number }}</h3></div>
      <div class="p-3 bg-green-50 text-green-600 rounded-full"><span class="material-icons">qr_code</span></div>
    </div>
    <div class="bg-white p-6 rounded-2xl shadow-sm border-l-4 border-blue-500 flex justify-between items-center transition-all hover:shadow-md">
      <div><p class="text-xs font-bold text-gray-400 uppercase mb-1">Product Sales</p><h3 class="text-2xl font-extrabold text-gray-800">₹ {{ productTypeSale | number }}</h3></div>
      <div class="p-3 bg-blue-50 text-blue-600 rounded-full"><span class="material-icons">label</span></div>
    </div>
  </div> -->

  <!-- 🔹 INCREASED CODE: PRODUCT DISTRIBUTION GRAPH -->
  <!-- <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 relative overflow-hidden">
    <p class="text-xs font-bold text-gray-400 uppercase tracking-widest mb-1">Product Mix Visualization</p>
    <div class="flex gap-3 mt-4 h-24 items-end px-2">
        <div class="flex-1 bg-orange-500 rounded-t transition-all duration-500 shadow-lg" [style.height.%]="lotPercent"></div>
        <div class="flex-1 bg-green-500 rounded-t transition-all duration-500 shadow-lg" [style.height.%]="piecePercent"></div>
        <div class="flex-1 bg-blue-500 rounded-t transition-all duration-500 shadow-lg" [style.height.%]="productPercent"></div>
    </div>
  </div> -->



  <!-- 3. MIDDLE ROW: Categories & Execs (Dynamic logic applied to original design) -->

  <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">

    <!-- Product Category Wise Sale -->
    <div class="bg-white rounded-2xl shadow-sm border border-gray-100 h-full flex flex-col">

      <!-- Card Header -->
      <div class="p-5 pb-3 border-b border-gray-50 flex justify-between items-center bg-white rounded-t-2xl">
        <h3 class="font-bold text-gray-800 mb-6 flex items-center gap-2">
          <span class="w-2 h-6 bg-yellow-500 rounded-full"></span> Product Category Wise Sale
        </h3>
        <button routerLink="/product-category-wise-sale"
          class="px-3 py-1.5 text-[10px] font-bold uppercase tracking-wide bg-orange-50 text-orange-600 rounded-lg hover:bg-orange-100 transition-colors">
          View Full Report
        </button>
      </div>

      <!--  Ready vs Assembly -->
      <div class="grid grid-cols-1 md:grid-cols-2 flex-grow">

        <!-- SECTION 1: Ready Products Sales (Dynamic List) -->
        <div class="p-2 border-r border-gray-100">
          <h4
            class="px-3 py-2 text-[10px] font-bold text-gray-400 uppercase tracking-wider flex items-center justify-between">
            <span>Ready Collection</span>
          </h4>

          <div class="overflow-x-auto">
            <table class="w-full text-left">
              <thead class="text-[9px] text-gray-400 uppercase tracking-wide border-b border-gray-50">
                <tr>
                  <th class="px-3 py-2 font-semibold">Item Name</th>
                  <th class="px-3 py-2 font-semibold text-right">Amount</th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-50 text-xs">
                <tr *ngFor="let item of dynamicReadyCategoryItems | slice:0:10"
                  class="hover:bg-orange-50/50 transition-colors group cursor-pointer">
                  <td class="px-3 py-2.5">
                    <p class="font-bold text-gray-700 text-xs group-hover:text-orange-600">{{item.name}}</p>
                    <span class="text-[9px] text-gray-400">{{item.sub}}</span>
                  </td>
                  <td class="px-3 py-2.5 text-right font-bold text-gray-800">₹{{item.amount | number}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- SECTION 2: Assembly Line Output (Dynamic List) -->
        <div class="p-2">
          <h4
            class="px-3 py-2 text-[10px] font-bold text-gray-400 uppercase tracking-wider flex items-center justify-between">
            <span>Assembly Line</span>
          </h4>

          <div class="overflow-x-auto">
            <table class="w-full text-left">
              <thead class="text-[9px] text-gray-400 uppercase tracking-wide border-b border-gray-50">
                <tr>
                  <th class="px-3 py-2 font-semibold">Stage</th>
                  <th class="px-3 py-2 font-semibold text-right">Est. Val</th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-50 text-xs">
                <tr *ngFor="let item of dynamicAssemblyCategoryItems | slice:0:10"
                  class="hover:bg-blue-50/50 transition-colors group cursor-pointer">
                  <td class="px-3 py-2.5 font-bold text-gray-700 text-xs group-hover:text-blue-600">{{item.name}}</td>
                  <td class="px-3 py-2.5 text-right font-bold text-gray-800">₹{{item.amount | number}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Sales Executive Sales (INCREASED CODE WITH PAGINATION) -->

    <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-all duration-300">
      <div class="flex items-center justify-between mb-6">
        <h3 class="font-bold text-gray-800 flex items-center gap-2">
          <span class="w-2 h-6 bg-blue-500 rounded-full"></span> Sales Executive Performance
        </h3>
        <!-- <button routerLink="/staff-dashboard"
            class="text-xs font-bold text-yellow-600 hover:text-yellow-700 hover:bg-yellow-50 px-3 py-1.5 rounded-lg uppercase tracking-wide transition-all">
            View All
          </button> -->
      </div>
      <div class="overflow-x-auto">
        <table class="w-full text-sm text-left">
          <thead class="text-xs text-gray-400 uppercase border-b border-gray-100">
            <tr>
              <th class="pb-3">Name</th>
              <th class="pb-3 text-center">Items Sold</th>
              <th class="pb-3 text-right">Value Achieved</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-50">
            <tr *ngFor="let staff of paginatedStaffPerformance" class="group hover:bg-gray-50 transition">
              <td class="py-3 font-medium text-gray-700">{{ staff.name }}</td>
              <td class="py-3 text-center">
                <span
                  class="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-bold bg-green-50 text-green-700 border border-green-100">
                  {{ staff.soldCount }} Sold
                </span>
              </td>
              <td class="py-3 font-bold text-gray-900 text-right">₹{{ staff.achievedValue | number }}</td>
            </tr>
            <tr *ngIf="staffPerformance.length === 0">
              <td colspan="3" class="py-10 text-center text-gray-400 italic">No sales data found</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- 🔹 PAGINATION FOOTER -->
      <div *ngIf="staffPerformance.length > pageSizeStaff"
        class="mt-4 pt-4 border-t border-gray-50 flex items-center justify-between">
        <p class="text-[10px] font-bold text-gray-400 uppercase">Page {{ currentPageStaff }} of {{ totalStaffPages }}
        </p>
        <div class="flex items-center gap-1">
          <button (click)="goToStaffPage(currentPageStaff - 1)" [disabled]="currentPageStaff === 1"
            class="p-1 px-2 text-[10px] font-bold border rounded bg-white hover:bg-gray-50 disabled:opacity-30">PREV</button>
          <button (click)="goToStaffPage(currentPageStaff + 1)" [disabled]="currentPageStaff === totalStaffPages"
            class="p-1 px-2 text-[10px] font-bold border rounded bg-white hover:bg-gray-50 disabled:opacity-30">NEXT</button>
        </div>
      </div>
    </div>
  </div>


  <!-- 4. NEW ADDITIONS (Maintained strictly) -->

  <div class="grid grid-cols-1 lg:grid-cols-2 gap-3">

    <!-- ADDITION: Expenses -->
    <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 relative overflow-hidden">
      <div class="flex justify-between items-start mb-4">
        <div>
          <p class="text-xs font-bold text-gray-400 uppercase tracking-widest mb-1">Total Expenses</p>
          <h3 class="text-2xl font-bold text-red-600"> ₹ {{ total_expense | number }}</h3>
        </div>
        <div class="p-2 bg-red-50 text-red-600 rounded-lg">
          <button routerLink="/expense" [queryParams]="{ tab: 'analytics' }"
            class="text-xs font-bold text-yellow-600 hover:text-yellow-700 hover:bg-yellow-50 px-3 py-1.5 rounded-lg uppercase tracking-wide transition-all">
            View All Expenses
          </button>
        </div>
      </div>
      <div class="flex gap-1 mt-4 h-16 items-end">
        <table class="w-full text-left">
          <thead class="text-[9px] text-gray-400 uppercase tracking-wide border-b border-gray-50">
            <!-- <tr>
              <th class="px-3 py-2 font-semibold">Staff Name</th>
              <th class="px-3 py-2 font-semibold text-right">Amount</th>
            </tr> -->
          </thead>
          <tbody class="divide-y divide-gray-50 text-xs">
            <tr *ngFor="let item of staffWiseExpenses | slice:0:10"
              class="hover:bg-orange-50/50 transition-colors group cursor-pointer">
              <td class="px-3 py-2.5">
                <p class="font-bold text-gray-700 text-xs group-hover:text-orange-600">{{item.user?.name}}</p>
                <span class="text-[9px] text-gray-400">Staff Member</span>
              </td>
              <td class="px-3 py-2.5 text-right font-bold text-gray-800">₹{{item.amount | number}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>


    <!-- TOP 10 CUSTOMERS -->
    <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">

      <div class="flex justify-between items-center mb-6">
        <h3 class="font-bold text-gray-800 flex items-center gap-2">
          <span class="w-2 h-6 bg-green-500 rounded-full"></span> Top 10 Customers
        </h3>
        <!-- <button routerLink="/top-ten-customers"
          class="text-xs font-bold text-yellow-600 hover:text-yellow-700 hover:bg-yellow-50 px-3 py-1.5 rounded-lg uppercase tracking-wide transition-all">
          View All Report
        </button> -->
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-3">
        <div *ngFor="let customer of topFourCustomers; let i = index"
          class="border border-gray-100 p-4 rounded-xl hover:shadow-md transition bg-gray-50 group cursor-pointer"
          [routerLink]="['/customer-dashboard', customer.in_customer_id]">
          <div class="flex justify-between items-start mb-1">
            <p class="text-sm font-bold text-gray-800 truncate">{{ customer.in_customer_name }}</p>
            <span class="text-[10px] font-bold px-1.5 py-0.5 rounded-full border bg-yellow-100 text-yellow-700">#{{ i +
              1 }}</span>
          </div>
          <div class="flex justify-between items-end border-t border-gray-200 pt-2 border-dashed mt-2">
            <div class="flex flex-col">
              <span
                class="text-[10px] font-semibold px-2 py-0.5 rounded bg-blue-100 text-blue-700 uppercase tracking-tighter w-fit mb-1">{{
                customer.user_customer_type }}</span>
            </div>
            <div class="text-right">
              <p class="text-[10px] text-gray-500 font-semibold">Total: ₹{{ customer.grand_total | number }}</p>
              <p class="text-[10px] text-green-600 font-semibold">Paid: ₹{{ customer.total_amount_paid | number }}</p>
              <p class="text-[10px] text-red-500 font-semibold">Due: ₹{{ customer.balance_due | number }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>



  <!-- 5. NEW added categories -->

  <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">

    <!-- LEFT HALF: New Added Categories (Compact & 4 Items each) -->
    <div class="bg-white p-5 rounded-2xl shadow-sm border border-gray-100 h-full flex flex-col">
      <!-- Header Section -->
      <div class="flex justify-between items-center mb-4">
        <h3 class="font-bold text-gray-800 flex items-center gap-2 text-sm">
          <span class="w-2 h-6 bg-purple-500 rounded-full"></span> New Added Categories
        </h3>
        <button routerLink="/new-added-categories"
          class="text-[10px] bg-purple-50 hover:bg-purple-100 text-purple-700 px-2 py-1 rounded border border-purple-100 font-bold uppercase tracking-wide transition-colors cursor-pointer">
          View All Report
        </button>
      </div>

      <!-- Internal Grid: Split into 2 small columns -->
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 flex-1">
        <!-- Category 1: Ready Products -->
        <div>
          <h4 class="text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-2 ml-1">Ready Products</h4>
          <div class="space-y-2" *ngIf="readyProducts?.length">
            <!-- Item 1 -->
            <a *ngFor="let item of readyProducts | slice:0:4" routerLink="/new-added-categories"
              class="block group cursor-pointer">
              <div
                class="flex items-center gap-2 p-2 rounded-lg border border-gray-100 bg-white group-hover:border-purple-200 group-hover:shadow-sm transition-all duration-200">
                <div
                  class="h-8 w-8 min-w-[2rem] bg-purple-50 text-purple-600 rounded shadow-sm flex items-center justify-center text-sm">
                  💎</div>
                <div class="overflow-hidden">
                  <p class="font-bold text-gray-800 text-xs truncate group-hover:text-purple-700"> {{ item.name }} </p>
                  <p class="text-[10px] text-gray-500"> {{ item.created_at }} </p>
                </div>
                <div class="ml-auto text-right">
                  <p class="text-[10px] font-bold text-green-600 bg-green-50 px-1.5 py-0.5 rounded"> ₹ {{ item.mrp }}
                  </p>
                </div>
              </div>
            </a>
          </div>
        </div>

        <!-- Category 2: Assembly Line -->
        <div>
          <h4 class="text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-2 ml-1">Assembly Line</h4>
          <div *ngIf="assemblyProducts && assemblyProducts.length > 0; else noAssembly">
            <a *ngFor="let item of assemblyProducts | slice:0:4" class="block group cursor-pointer">
              <div class="flex items-center gap-2 p-2 rounded-lg border border-gray-100 bg-white">
                <div class="h-8 w-8 bg-blue-50 text-blue-600 rounded flex items-center justify-center">⚒️</div>
                <div>
                  <p class="text-sm font-semibold">{{ item.name }}</p>
                  <p class="text-xs text-gray-500">{{ item.created_at }}</p>
                </div>
                <div class="ml-auto text-xs font-bold">₹ {{ item.mrp }}</div>
              </div>
            </a>
          </div>

          <ng-template #noAssembly>
            <p class="text-xs text-gray-400">No assembly products</p>
          </ng-template>

        </div>

      </div>
    </div>

    <div class="bg-white rounded-2xl shadow-sm border border-gray-100 h-full flex flex-col">
      <div class="p-5 pb-3 border-b border-gray-50 flex justify-between items-center bg-white rounded-t-2xl">
        <h3 class="font-bold text-gray-800 flex items-center gap-2 text-sm">
          <span class="w-2 h-6 bg-orange-500 rounded-full"></span> Product Wise Sale
        </h3>
        <button routerLink="/product-wise-sale"
          class="px-3 py-1.5 text-[10px] font-bold uppercase tracking-wide bg-orange-50 text-orange-600 rounded-lg hover:bg-orange-100 transition-colors">
          View Full Report
        </button>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-2 flex-grow p-4">
        <div class="p-2 border-r border-gray-100">
          <h4 class="px-3 py-1 text-[9px] font-bold text-gray-400 uppercase">Ready Collection</h4>
          <table class="w-full text-xs text-left">
            <tbody class="divide-y divide-gray-50">
              <tr *ngFor="let item of dynamicReadyCategoryItems | slice:0:5"
                class="hover:bg-orange-50/50 transition-colors cursor-pointer">
                <td class="py-2 font-bold text-gray-700">{{item.name}}</td>
                <td class="py-2 text-right font-bold text-gray-800">₹{{item.amount | number}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="p-2">
          <h4 class="px-3 py-1 text-[9px] font-bold text-gray-400 uppercase">Assembly</h4>
          <table class="w-full text-left text-xs">
            <tbody class="divide-y divide-gray-50">
              <tr *ngFor="let item of dynamicAssemblyCategoryItems | slice:0:5"
                class="hover:bg-blue-50/50 transition-colors cursor-pointer">
                <td class="py-2 font-bold text-gray-700">{{item.name}}</td>
                <td class="py-2 text-right font-bold text-gray-800">₹{{item.amount | number}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

</div>